import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DocumentationState } from "../objects/documentationState";
import { DocumentationTag } from "../objects/documentation";

const initialState: DocumentationState = {
    all_documentation: undefined,
    tags: []
};

const setAllDocumenationReducer = (state: DocumentationState, action: PayloadAction<any>): DocumentationState => ({
    ...state, all_documentation: action.payload
});

const setTagsReducer = (state: DocumentationState, action: PayloadAction<DocumentationTag[]>): DocumentationState => ({
    ...state, tags: action.payload
});

export const documentationSlice = createSlice({
    name: 'documentation',
    initialState,
    reducers: {
        setAllDocumentation: setAllDocumenationReducer,
        setTags: setTagsReducer
    },
});

export const { setAllDocumentation, setTags } = documentationSlice.actions;